const SERVER_DOMAIN = `https://erin-careful-fly.cyclic.app/`
// const SERVER_DOMAIN = `https://erin-careful-fly.cyclic.app/`
const CLIENT_ID = "452449154803-iad02uue0qlqoca6fnngi9062q8mfkor.apps.googleusercontent.com"
export { SERVER_DOMAIN, CLIENT_ID }